import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*() {
  return yield oncallFetch("/api/oncall/partners/regions/list", {});
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/regions/list.js